var shim = { exports: {} };
export {
  shim as __module
};
//# sourceMappingURL=index2.js.map
